import React, { Component } from 'react';
import cx from 'classnames';
import { Checkbox } from 'antd';
import './CheckBox.scss';

class CheckBox extends Component {
  render() {
    const { className, onChange, text, ...res } = this.props;

    return (
      <Checkbox
        className={cx('amondz-checkbox', className)}
        onChange={(e) => onChange && onChange(e.target.checked)}
        {...res}
      >
        {text}
      </Checkbox>
    );
  }
}

export default CheckBox;
